import {useCallback, useEffect, useState} from 'react';

import {isProduction} from '@/utils/environment';
import logError from '@/utils/errors/logError';

const skipPhoneValidationStorage = 'is_skip_phone_validation_enabled';

export const useSkipPhoneValidation = () => {
  const [isSkipPhoneValidationEnabled, setIsSkipPhoneValidationEnabled] =
    useState(false);

  useEffect(() => {
    try {
      const skipPhoneValidationStorageValue = localStorage.getItem(
        skipPhoneValidationStorage,
      );
      setIsSkipPhoneValidationEnabled(
        !isProduction && skipPhoneValidationStorageValue === 'true',
      );
    } catch (error) {
      logError(error, {
        fileName: 'SkipPhoneValidation',
        functionName: 'useSkipPhoneValidation (init)',
      });
    }
  }, []);

  const setSkipPhoneValidationStorage = useCallback((value: boolean) => {
    try {
      localStorage.setItem(skipPhoneValidationStorage, value.toString());
    } catch (error) {
      logError(error, {
        fileName: 'SkipPhoneValidation',
        functionName: 'setSkipPhoneValidationStorage',
      });
    }
    setIsSkipPhoneValidationEnabled(value);
  }, []);

  const removeSkipPhoneValidationStorage = useCallback(() => {
    try {
      localStorage.removeItem(skipPhoneValidationStorage);
    } catch (error) {
      logError(error, {
        fileName: 'SkipPhoneValidation',
        functionName: 'removeSkipPhoneValidationStorage',
      });
    }
    setIsSkipPhoneValidationEnabled(false);
  }, []);

  return {
    isSkipPhoneValidationEnabled,
    setSkipPhoneValidationStorage,
    removeSkipPhoneValidationStorage,
  };
};
